import { BG_SCHEMA, TITLE_SCHEMA, TEXT_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const GALLERY_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'gallery',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Galeria'),
    text: TEXT_SCHEMA(),
    bg: BG_SCHEMA(),
    items: ['https://cdn.blueticket.com.br/assets/login_background.png']
  }
}

export const beforeParseGallery = target => {
  commonBeforeParseMethod(target, ['bg'])
}

export const GALLERY_SECTION = config => ({
  schema: GALLERY_SCHEMA(config),
  beforeParse: beforeParseGallery
})
